(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/animated-backgrounds.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/animated-backgrounds.js');
"use strict";


setGlobal('svs.tickets.play.components.AnimatedBackgrounds', _ref => {
  var _window$matchMedia;
  let {
    ticketInfo
  } = _ref;
  const {
    SnowyBackground,
    HeartBackground
  } = svs.tickets.play.components;
  const backgroundMap = {
    snowflakes: SnowyBackground,
    hearts: HeartBackground
  };
  const prefersReducedMotion = !!((_window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)')) !== null && _window$matchMedia !== void 0 && _window$matchMedia.matches);
  const Background = backgroundMap[ticketInfo.animatedBackground];
  if (prefersReducedMotion || !Background) return null;
  return React.createElement(Background, null);
});

 })(window);